import {ArticleSummary} from './ArticleSummary';
export default ArticleSummary;
